'use client';
import useWindowHeight from '../../../../utils/useWindowHeight';
import { useEffect } from 'react';
import useIsMobile from '../../../../utils/useIsMobile';

type Props = {
  offset?: number;
};

const ForceHeaderHeight = ({ offset = 0 }: Props) => {
  const isMobile = useIsMobile();
  const { innerHeight } = useWindowHeight();
  useEffect(() => {
    if (!isMobile || !innerHeight) return;
    const el = document.getElementById('force-height');

    if (!el) return;
    el.style.height = `${innerHeight - offset}px`;
  }, [isMobile, innerHeight]);
  return null;
};

export default ForceHeaderHeight;
